<template>
	<v-expansion-panels>
		<v-expansion-panel>
			<v-expansion-panel-header>
				{{ $t("Filter") }}
			</v-expansion-panel-header>
			<v-divider></v-divider>
			<v-expansion-panel-content>
				<v-layout row wrap>
					<v-flex xs12 md3>
						<v-text-field
							v-model="filter.name"
							type="text"
							:placeholder="$t('Name')"
							clearable
							hide-details
						></v-text-field>
					</v-flex>
					<v-flex xs12 md3>
						<v-text-field
							v-model="filter.description"
							type="text"
							:placeholder="$t('Description')"
							clearable
							hide-details
						></v-text-field>
					</v-flex>
				</v-layout>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
export default {
	props: ["value"],
	computed: {
		filter: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
	watch: {
		filter: {
			handler() {
				this.$emit("filter");
			},
			deep: true,
		},
	},
};
</script>